import { useScreenSize } from '../components/window-size-listener/store';

export function useWindowSize() {
  return useScreenSize((state) => state.size);
}
